import { HttpParams, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiResponse } from "../../../../../core/models";
import { BaseApiService } from "../../../../../core/services/base-api.service";
import { ShoppingCartRepository } from "../contracts/shopping-cart.repository";
import type { AddItemsToShoppingCartRequest } from "../../models/add-items-to-cart.model";
import type {
  ShoppingCartItemListDTO,
  UpdateShoppingCartItemsStatusRequest,
} from "../../models/shopping-cart-list.model";

@Injectable({
  providedIn: "root",
})
export class ShoppingCartHttpRepository
  extends BaseApiService
  implements ShoppingCartRepository
{
  /** POST /api/v1/ShoppingCart/initialize-shopping-cart */
  public initializeShoppingCart(payerId: string): Observable<
    HttpResponse<ApiResponse<boolean>>
  > {
    return this.http.post<ApiResponse<boolean>>(
      `${this.baseUrl}/ShoppingCart/initialize-shopping-cart`,
      { payerId },
      { observe: "response", withCredentials: true },
    );
  }

  /** POST /api/v1/ShoppingCart/add-items */
  public addItemsToShoppingCart(
    request: AddItemsToShoppingCartRequest,
  ): Observable<HttpResponse<ApiResponse<boolean>>> {
    return this.http.post<ApiResponse<boolean>>(
      `${this.baseUrl}/ShoppingCart/add-items`,
      request,
      { observe: "response", withCredentials: true },
    );
  }

  /** GET /api/v1/ShoppingCart/list?statusCodes=... */
  public getShoppingCartItemsList(
    statusCodes?: string,
  ): Observable<HttpResponse<ApiResponse<ShoppingCartItemListDTO>>> {
    let params = new HttpParams();
    const codes = statusCodes?.trim();
    if (codes) {
      params = params.set("statusCodes", codes);
    }
    return this.http.get<ApiResponse<ShoppingCartItemListDTO>>(
      `${this.baseUrl}/ShoppingCart/list`,
      { observe: "response", params, withCredentials: true },
    );
  }

  /** POST /api/v1/ShoppingCart/update-items-status */
  public updateShoppingCartItemsStatus(
    request: UpdateShoppingCartItemsStatusRequest,
  ): Observable<HttpResponse<ApiResponse<boolean>>> {
    return this.http.post<ApiResponse<boolean>>(
      `${this.baseUrl}/ShoppingCart/update-items-status`,
      request,
      { observe: "response", withCredentials: true },
    );
  }
}
